export enum Category {
  NeedsAHelpingHand,
  WorkingAtAnAppropriateLevel,
  ReadyToBeChallenged,
  TimeToPractice
}
